import * as yup from "yup";
/*
 * @helper schemas
 */
const imageValidationSchema = yup
  .mixed()
  .test("fileType", "Unsupported image format", (value) => {
    if (typeof value === "string") return true; // Skip validation if it's a string
    if (value === null || value === undefined) return true;
    return (
      value instanceof File &&
      ["image/jpeg", "image/png", "image/gif"].includes(value.type)
    );
  })
  .test("fileSize", "File is too large", (value) => {
    if (typeof value === "string") return true; // Skip validation if it's a string
    if (value === null || value === undefined) return true;
    return value instanceof File && value.size <= 1 * 1024 * 1024; // 5 MB limit
  });

const multiselectSchema = yup
  .object({
    label: yup.string().required("Deformed data"),
    value: yup.string().required("Deformed data"),
  })
  .stripUnknown();

const common = yup.object().shape({
  title: yup.string().required("Title of page cannot be empty"),
  description: yup
    .string()
    .transform((value) => {
      if (!value) return "";
      else return value;
    })
    .nullable()
    .optional(),
  html_content: yup.string().nullable().optional(),
  css_content: yup.string().optional().nullable(),
  json_content: yup.string().optional().nullable(),
  is_removeable: yup.bool().optional().default(true).nullable(),
});

const popupValidation = common
  .shape({
    is_popup: yup.bool().default(true).nullable().optional(),
  })
  .stripUnknown();
const jsonStringValidation = yup
  .string()
  .test("is-json", "JSON-LD must be a valid JSON string", (value) => {
    try {
      JSON.parse(value);
      return true;
    } catch (error) {
      return false;
    }
  });

const createThemeValidation = yup.object().shape({
  title: yup.string().required("Title is required"),
  theme_settings: yup.object().required("Theme is required"),
  color: yup.string().required("Pickup a color first"),
  json_ld: jsonStringValidation.optional().nullable(),
});

const createSEOValidation = yup.object().shape({
  title: yup.string().required("Title is required"),
  keywords: yup.string().required("Keywords is required"),
  description: yup.string().required("Description is required"),
  image: yup
    .mixed()
    .required("Image is required")
    .test("fileType", "Image is required", (value: any) => {
      if (!value || !value.type) return false;
      return ["image/jpeg", "image/png", "image/gif", "image/webp"].includes(
        value.type
      );
    }),
});

const pageValidation = common
  .shape({
    is_popup: yup.bool().default(false).nullable().optional(),
    popup_pages: yup.array().of(multiselectSchema).optional().nullable(),
    page_contents: yup
      .object({
        css_content: yup.string().nullable("No css values"),
        html_content: yup.string().nullable("No css values"),
        project_data: yup.mixed(),
      })
      .nullable()
      .optional(),
  })
  .stripUnknown();

const navigationValidation = yup
  .object({
    pages: yup
      .object({
        id: yup
          .string()
          .uuid()
          .required("A page must be selected for navigation"),
      })
      .stripUnknown()
      .nonNullable("A page must be selected for navigation"),
    is_external: yup.boolean().default(false).nullable(),
    is_redirect: yup.boolean().default(false).nullable(),
    path: yup
      .string()
      .required("A path must be provided")
      .nonNullable("A Path must be provided"),
    order: yup
      .number()
      .positive("Order must be postive")
      .min(0, "Minimum value can be 0")
      .nonNullable("Minimum value can be 0"),
    name: yup
      .string()
      .required("A name must be provided.")
      .nonNullable("A name must be provided."),
  })
  .stripUnknown();

const componentValidation = yup
  .object({
    name: yup
      .string()
      .max(255, "Name cannot be greater than 255 characters")
      .required("Title of page cannot be empty"),
    content: yup.string().nullable().optional(),
  })
  .stripUnknown();

export {
  pageValidation,
  navigationValidation,
  componentValidation,
  popupValidation,
  createThemeValidation,
  createSEOValidation,
};
